import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {trackEvent} from 'analytics/Analytics';
import {assertAndContinue} from 'Asserts';
import {DATA_FRAMES_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {DataFrame} from 'data-frames/DataFrameTypes';
import {DataFrameTableMode} from 'data-frames/table/DataFrameTableConstants';
import {BLUE_LIGHT, GRAY} from 'ui-library/Colors';
import Option from 'ui-library/menus/Option';

import {ToolbarActionRenderParams} from '../DataFrameActionToolbar';

export default function renderToggleChipsOption(
  dataFrame: DataFrame,
  params: ToolbarActionRenderParams
): JSX.Element {
  assertAndContinue(
    params.tableMode === DataFrameTableMode.RICH || params.tableMode === DataFrameTableMode.TEXT,
    'renderToggleChipsOption only supports RICH and TEXT modes',
    {tableMode: params.tableMode}
  );
  return (
    <Option
      icon="check"
      iconClassName={css(params.tableMode === DataFrameTableMode.RICH ? styles.richIcon : styles.textIcon)}
      key="ToggleChipsOption"
      onSelect={() => {
        const newTableMode =
          params.tableMode === DataFrameTableMode.RICH ? DataFrameTableMode.TEXT : DataFrameTableMode.RICH;

        trackEvent(DATA_FRAMES_ANALYTICS_ACTIONS.UPDATED_DATA_FRAME_TABLE_MODE, {
          data_frame_id: params.dataFrameId,
          action_origin: params.actionOrigin,
          new_table_mode: newTableMode,
        });
        params.setTableMode(newTableMode);
      }}
    >
      Show chips in table
    </Option>
  );
}

const styles = StyleSheet.create({
  richIcon: {
    color: BLUE_LIGHT,
  },
  textIcon: {
    color: GRAY,
  },
});
